import React from 'react';
import { Badge } from './ui/badge';
import { Wifi, WifiOff, Users } from 'lucide-react';
import { cn } from '../lib/utils';

export function ConnectionStatus({ connected, presenceCount = 0, className }) {
  return (
    <div className={cn('flex items-center gap-3', className)} data-testid="connection-status">
      {/* WebSocket connection indicator */}
      <Badge
        variant={connected ? 'default' : 'destructive'}
        className={cn(
          'flex items-center gap-1.5 px-2.5 py-1',
          connected ? 'bg-green-100 text-green-700 hover:bg-green-100' : 'bg-red-100 text-red-700'
        )}
        data-testid="ws-status-badge"
      >
        {connected ? (
          <>
            <Wifi className="h-3 w-3" />
            <span className="text-xs font-medium">Live</span>
          </>
        ) : (
          <>
            <WifiOff className="h-3 w-3" />
            <span className="text-xs font-medium">Reconnecting...</span>
          </>
        )}
      </Badge>

      {/* Presence indicator (online users) */}
      {connected && presenceCount > 0 && (
        <Badge
          variant="secondary"
          className="flex items-center gap-1.5 px-2.5 py-1 bg-blue-50 text-blue-700"
          data-testid="presence-count-badge"
        >
          <Users className="h-3 w-3" />
          <span className="text-xs font-medium">
            {presenceCount} {presenceCount === 1 ? 'viewer' : 'viewers'}
          </span>
        </Badge>
      )}
    </div>
  );
}
